<template>
  <div>
    <div class="nav">
      <v-head></v-head>
    </div>
    <v-route></v-route>
    <div class="w1200">
      <v-breadcrumb
        value1="首页"
        value2="玩转廉江"
        :value3="value"
        :url="url"
      ></v-breadcrumb>
       <div
        style="
          float: right;
          margin-top: -40px;
          font-size: 18px;
          display: flex;
          align-items: center;
        ">
        <i class="el-icon-search" style="font-size: 20px"></i>
        <el-button style="color: #000" type="text" @click="search"
          >查询更多</el-button
        >
      </div>
    </div>

    <div class="container" id="container2" v-if="datalist.list.length > 0">
      <div class="listH2">购物</div>

      <div class="container_box">
        <div
          class="container_box_left"
          @click="toDetail(datalist.list[0].path)"
        >
          <img
            class="hover"
            style="width: 100%"
            :src="datalist.list[0].coverImageUrl"
          />
          <div class="title hover">{{ datalist.list[0].title }}</div>
          <p class="hover">
            {{ datalist.list[0].summary }}
          </p>
          <a href="javascript:;">了解更多</a>
        </div>
        <div class="container_box_right">
          <div
            class="item"
            v-for="(i, j) in datalist.list"
            v-if="0 < j && j < 5"
            @click="toDetail(i.path)"
          >
            <img class="hover" :src="i.coverImageUrl" />
            <div class="title hover">{{ i.title }}</div>
            <a href="javascript:;" class="index_more">了解更多</a>
          </div>
        </div>
      </div>
       <div class="hidebox">
        <div
          class="itemBox"
          v-for="(i, j) in datalist.list"
          v-if="4 < j && j < 9"
          @click="toDetail(i.path)"
        >
          <img class="hover" :src="i.coverImageUrl" />
          <div class="title">{{ i.title }}</div>
          <a href="javascript:;" class="index_more">了解更多</a>
        </div>
      </div>

      <div class="hidebox">
        <div
          class="itemBox"
          v-for="(i, j) in datalist.list"
          v-if="8 < j && j < 13"
          @click="toDetail(i.path)"
        >
          <img class="hover" :src="i.coverImageUrl" />
          <div class="title">{{ i.title }}</div>
          <a href="javascript:;" class="index_more">了解更多</a>
        </div>
      </div>

      <div class="hidebox">
        <div
          class="itemBox"
          v-for="(i, j) in datalist.list"
          v-if="12 < j && j < 17"
          @click="toDetail(i.path)"
        >
          <img class="hover" :src="i.coverImageUrl" />
          <div class="title">{{ i.title }}</div>
          <a href="javascript:;" class="index_more">了解更多</a>
        </div>
      </div>
      <button
        class="pages"
        @click="loadPage()"
        v-if="
          datalist.totalCount - datalist.pageSize * datalist.currentPage > 0
        "
      >
        剩余{{
          datalist.totalCount - datalist.pageSize * datalist.currentPage
        }}项,展开更多
      </button>
    </div>

    <v-footer></v-footer>
  </div>
</template>

<script>
import route from "../../components/common/route";
export default {
  name: "list1",
  data() {
    return {
      ljcode: null,
      class: {},
      columnId: null,
      rootColumnId: null,
      url: null,
      value: null,

      datalist: null,
      pageSize: 5,
      currentPage: 1,
    };
  },
  created() {
    this.ljcode = this.$route.query.ljcode;
    var obj = {
      yw: "游玩",
      gw: "购物",
      ms: "美食",
      cx: "出行",
      yl: "娱乐",
      zs: "住宿",
      tc: "特产",
       jd:"红色景点"
    };
    this.value = obj[this.ljcode];

    this.columnId = this.$route.query.columnId;
    this.rootColumnId = this.$route.query.rootColumnId;
    this.url = ["wzlj_gw", this.rootColumnId, this.columnId];
    this.getList();
  },
  watch: {
    $route: function (newValue) {
      console.log(newValue);
      this.ljcode = newValue.query.ljcode;
      this.columnId = newValue.query.columnId;
      this.rootColumnId = this.$route.query.rootColumnId;
      var obj = {
        yw: "游玩",
        gw: "购物",
        ms: "美食",
        cx: "出行",
        yl: "娱乐",
        zs: "住宿",
        tc: "特产",
         jd:"红色景点"
      };
      this.value = obj[this.ljcode];
      this.getList();
    },
  },
  methods: {
    loadPage() {
      this.pageSize += 8;
      if (
        this.datalist.totalCount -
          this.datalist.pageSize * this.datalist.currentPage >
        0
      ) {
        this.getList();
      }
    },
    getList() {
      let that = this;
      let url = `${api}/api/cms/article/list?rootColumnId=${this.rootColumnId}&columnId=${this.columnId}&type=&pageSize=${this.pageSize}&currentPage=${this.currentPage}`;
      this.common.axios.get(url).then((v) => {
        let data = v.data.data;
        data.list.forEach((v) => {
          v.coverImageUrl = apiimg + (v.coverImageUrl ? v.coverImageUrl : "");
          v.path = `rootColumnId=${this.rootColumnId}&columnId=${this.columnId}&articleId=${v.id}`;
        });
        this.datalist = data;
        console.log(this.datalist);
      });
    },

    toDetail(v) {
        let url =  `/gw?${v}`
                this.$router.replace({path:url})
    },
    search() {
      let url = `/xzlm?rootColumnId=${this.rootColumnId}&columnId=${this.columnId}&type=购物`;
      this.$router.replace({ path: url });
    },
  },
  components: {
    "v-route": route,
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/wzlj";
</style>
